import React, { FunctionComponent, useState } from "react";
import { Aside, ListActionButtonProps, Stack } from "sprint-common-web";

import { EditListButton } from "../../../../common/components/buttons/EditListButton";
import { EditUserForm } from "../forms/edit/EditUserForm";
import { UserItem } from "../UsersListing";

export const EditUserButton: FunctionComponent<ListActionButtonProps<UserItem>> = (
    props: ListActionButtonProps<UserItem>
) => {
    const { item } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <EditListButton onClick={openAside} />
            <Aside type={"form"} isOpen={isAsideOpen} headerText="Edit user" onDismiss={closeAside}>
                <Stack>
                    <EditUserForm onCancel={closeAside} onSubmit={handleFormSubmit} item={item} />
                </Stack>
            </Aside>
        </>
    );
};
